module.exports = __webpack_public_path__ + "static/img/pact.89e57ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/pact.jpg
// module id = Z4Cc
// module chunks = 1